const translations = {
  selectChecklistTypes: 'Seleção de tipo de questionário',
  type: 'Tipo',
  checklistType: 'Tipo de checklist'
}

export default translations
